import _defineProperty from "/home/runner/work/react/react/docs/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/home/runner/work/react/react/docs/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/runner/work/react/react/docs/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/react/react/docs/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/react/react/docs/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/react/react/docs/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/react/react/docs/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var t = new Set(["children", "localName", "ref", "style", "className"]),
    n = new WeakMap(),
    e = function e(t, _e, i, s, o) {
  var l = null == o ? void 0 : o[_e];
  void 0 !== l ? i !== s && function (t, e, i) {
    var s = n.get(t);
    void 0 === s && n.set(t, s = new Map());
    var o = s.get(e);
    void 0 !== i ? void 0 === o ? (s.set(e, o = {
      handleEvent: i
    }), t.addEventListener(e, o)) : o.handleEvent = i : void 0 !== o && (s.delete(e), t.removeEventListener(e, o));
  }(t, l, i) : t[_e] = i;
},
    i = function i(n, _i2, s, o, l) {
  var d = n.Component,
      c = n.createElement,
      h = new Set(Object.keys(null != o ? o : {}));

  var r = /*#__PURE__*/function (_d) {
    _inherits(r, _d);

    var _super = _createSuper(r);

    function r() {
      var _this;

      _classCallCheck(this, r);

      _this = _super.apply(this, arguments), _this.o = null;
      return _this;
    }

    _createClass(r, [{
      key: "t",
      value: function t(_t) {
        if (null !== this.o) for (var _n in this.i) {
          e(this.o, _n, this.props[_n], _t ? _t[_n] : void 0, o);
        }
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        this.t();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(t) {
        this.t(t);
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var n;
        var e = null !== (n = this.props._$Gl) && void 0 !== n ? n : null;
        void 0 !== this.h && this.u === e || (this.h = function (t) {
          null === _this2.o && (_this2.o = t), null !== e && function (t, n) {
            "function" == typeof t ? t(n) : t.current = n;
          }(e, t), _this2.u = e;
        });
        var o = {
          ref: this.h
        };
        this.i = {};

        for (var _i = 0, _Object$entries = Object.entries(this.props); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
              _n2 = _Object$entries$_i[0],
              _e2 = _Object$entries$_i[1];

          "__forwardedRef" !== _n2 && (h.has(_n2) || !t.has(_n2) && !(_n2 in HTMLElement.prototype) && _n2 in s.prototype ? this.i[_n2] = _e2 : o["className" === _n2 ? "class" : _n2] = _e2);
        }

        return c(_i2, o);
      }
    }]);

    return r;
  }(d);

  r.displayName = null != l ? l : s.name;
  var u = n.forwardRef(function (t, n) {
    return c(r, _objectSpread(_objectSpread({}, t), {}, {
      _$Gl: n
    }), null == t ? void 0 : t.children);
  });
  return u.displayName = r.displayName, u;
};

export { i as createComponent };